"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setShippingCountriesAvailable = exports.setCountriesFromLocalStorage = exports["default"] = exports.fetchCountriesShipping = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _agent = require("@deosite/agent");
var _toolkit = require("@reduxjs/toolkit");
var _mapAvailableCountries = _interopRequireDefault(require("@deosite/helpers/mapAvailableCountries"));
var initialState = {
  countries: null,
  shippingCountriesAvailable: null,
  loading: false,
  error: ""
};
var fetchCountriesShipping = (0, _toolkit.createAsyncThunk)("shipping/getCountries", /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(arg) {
    var language, domain;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            language = arg.language, domain = arg.domain;
            _context.next = 3;
            return _agent.requests.get("/directory/countries", false, null, {
              language: language,
              domain: domain
            });
          case 3:
            return _context.abrupt("return", _context.sent);
          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());
exports.fetchCountriesShipping = fetchCountriesShipping;
var countriesShipping = (0, _toolkit.createSlice)({
  name: "countriesShipping",
  initialState: initialState,
  reducers: {
    setCountriesFromLocalStorage: function setCountriesFromLocalStorage(state, action) {
      state.countries = action.payload;
    },
    setShippingCountriesAvailable: function setShippingCountriesAvailable(state, action) {
      state.shippingCountriesAvailable = action.payload;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchCountriesShipping.pending, function (state) {
      state.loading = true;
    });
    builder.addCase(fetchCountriesShipping.fulfilled, function (state, action) {
      var _localStorage;
      state.loading = false;
      var mappedCountries = (0, _mapAvailableCountries["default"])(action.payload);
      (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.setItem("availableCountries", JSON.stringify(mappedCountries));
      state.countries = mappedCountries;
    });
    builder.addCase(fetchCountriesShipping.rejected, function (state, action) {
      state.loading = false;
      state.error = action.error.message;
    });
  }
});
var _default = countriesShipping.reducer;
exports["default"] = _default;
var _countriesShipping$ac = countriesShipping.actions,
  setCountriesFromLocalStorage = _countriesShipping$ac.setCountriesFromLocalStorage,
  setShippingCountriesAvailable = _countriesShipping$ac.setShippingCountriesAvailable;
exports.setShippingCountriesAvailable = setShippingCountriesAvailable;
exports.setCountriesFromLocalStorage = setCountriesFromLocalStorage;